import './SitKpiHeader.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {Tooltip} from "@mui/material";

/**
 * KPI header pills — ported from the Mithra 3.0 design (`.m3-kpi`): an outline
 * pill with a coloured icon, a muted label and a bold value. Replaces the
 * generic KpiBoxedValues on the Savings Initiative Tracker and is reused by
 * the Contract Explorer and Payment Terms modules.
 */
export type SitKpiPill = {
    icon: React.ReactNode;
    tone: 'ok' | 'info' | 'warn' | 'plain';
    label: React.ReactNode;
    value: React.ReactNode;
    /** Optional explanation, shown as a tooltip on hover. */
    help?: React.ReactNode;
};

export const SitKpiHeader: React.FC<{items: SitKpiPill[]}> = observer(({items}) => (
    <div className="sit-kpis">
        {items.map((k, i) => {
            const pill = (
                <span key={i} className={'sit-kpi-pill tone-' + k.tone}>
                    {k.icon}
                    <span className="sit-kpi-label">{k.label}:</span>
                    <b>{k.value}</b>
                </span>
            );
            return k.help
                ? <Tooltip key={i} title={k.help} placement="bottom" arrow>{pill}</Tooltip>
                : pill;
        })}
    </div>
));
